/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as restrictedRouteRouteImport } from './routes/(restricted)/route'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as restrictedByggeradarAccessRouteRouteImport } from './routes/(restricted)/byggeradar/_access/route'
import { Route as restrictedCheckoutIndexRouteImport } from './routes/(restricted)/checkout/index'
import { Route as restrictedCheckoutCallbackRouteImport } from './routes/(restricted)/checkout/callback'
import { Route as restrictedEjendommeIndexRouteImport } from './routes/(restricted)/ejendomme/index'
import { Route as restrictedEjendommeStreetNumberIdRouteImport } from './routes/(restricted)/ejendomme/$streetNumberId'
import { Route as restrictedEjendomstjeksearchRouteRouteImport } from './routes/(restricted)/ejendomstjek/(search)/route'
import { Route as restrictedEjendomstjekAddressRouteRouteImport } from './routes/(restricted)/ejendomstjek/address/route'
import { Route as restrictedProfilIndexRouteImport } from './routes/(restricted)/profil/index'
import { Route as restrictedRapporterIndexRouteImport } from './routes/(restricted)/rapporter/index'
import { Route as restrictedStaffIndexRouteImport } from './routes/(restricted)/staff/index'
import { Route as restrictedVirksomhederV2IndexRouteImport } from './routes/(restricted)/virksomheder-v2/index'
import { Route as restrictedVirksomhederCvrRouteRouteImport } from './routes/(restricted)/virksomheder/$cvr/route'
import { Route as restrictedVirksomhedersearchRouteRouteImport } from './routes/(restricted)/virksomheder/(search)/route'
import { Route as AuthResetPasswordTokenRouteImport } from './routes/auth/reset-password.$token'
import { Route as AuthVerifyEmailTokenRouteImport } from './routes/auth/verify-email.$token'
import { Route as restrictedByggeradarAccesslandingRouteRouteImport } from './routes/(restricted)/byggeradar/_access/(landing)/route'
import { Route as restrictedByggeradarAccessSearchRouteRouteImport } from './routes/(restricted)/byggeradar/_access/search/route'
import { Route as restrictedByggeradarSavedSplatRouteImport } from './routes/(restricted)/byggeradar/saved/$'
import { Route as restrictedEjendommeBfeBfeNumberRouteImport } from './routes/(restricted)/ejendomme/bfe.$bfeNumber'
import { Route as restrictedRapporterReportSlugIndexRouteImport } from './routes/(restricted)/rapporter/$reportSlug/index'
import { Route as restrictedVirksomhederCvrEjerstrukturRouteImport } from './routes/(restricted)/virksomheder/$cvr/ejerstruktur'
import { Route as restrictedVirksomhederCvrRegnskabRouteImport } from './routes/(restricted)/virksomheder/$cvr/regnskab'
import { Route as restrictedVirksomhederCvrStamdataRouteImport } from './routes/(restricted)/virksomheder/$cvr/stamdata'
import { Route as restrictedByggeradarAccesslandingIndexRouteImport } from './routes/(restricted)/byggeradar/_access/(landing)/index'
import { Route as restrictedByggeradarAccessAgentAgentIdRouteImport } from './routes/(restricted)/byggeradar/_access/agent/$agentId'
import { Route as restrictedByggeradarAccessCollectionCollectionIdRouteImport } from './routes/(restricted)/byggeradar/_access/collection/$collectionId'
import { Route as restrictedByggeradarAccessSearchProposalIdRouteImport } from './routes/(restricted)/byggeradar/_access/search/$proposalId'
import { Route as restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRouteImport } from './routes/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/route'
import { Route as restrictedByggeradarAccessAgentAgentIdProposalIdRouteImport } from './routes/(restricted)/byggeradar/_access/agent/$agentId.$proposalId'
import { Route as restrictedByggeradarAccessCollectionCollectionIdProposalIdRouteImport } from './routes/(restricted)/byggeradar/_access/collection/$collectionId.$proposalId'
import { Route as restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125OverviewChar123UnitIdChar125RouteImport } from './routes/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/overview/{-$unitId}'
import { Route as restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RentAnalysisChar123UnitIdChar125RouteImport } from './routes/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/rent-analysis/{-$unitId}'
import { Route as restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RentingOutChar123UnitIdChar125RouteImport } from './routes/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/renting-out/{-$unitId}'
import { Route as restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RestrictionsChar123CurrentPlaceIdChar125RouteImport } from './routes/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/restrictions/{-$currentPlaceId}'
import { Route as restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125SalesPricesChar123BfeNumberChar125RouteImport } from './routes/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/sales-prices/{-$bfeNumber}'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const restrictedRouteRoute = restrictedRouteRouteImport.update({
  id: '/(restricted)',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const restrictedByggeradarAccessRouteRoute =
  restrictedByggeradarAccessRouteRouteImport.update({
    id: '/byggeradar/_access',
    path: '/byggeradar',
    getParentRoute: () => restrictedRouteRoute,
  } as any)
const restrictedCheckoutIndexRoute = restrictedCheckoutIndexRouteImport.update({
  id: '/checkout/',
  path: '/checkout/',
  getParentRoute: () => restrictedRouteRoute,
} as any)
const restrictedCheckoutCallbackRoute =
  restrictedCheckoutCallbackRouteImport.update({
    id: '/checkout/callback',
    path: '/checkout/callback',
    getParentRoute: () => restrictedRouteRoute,
  } as any)
const restrictedEjendommeIndexRoute =
  restrictedEjendommeIndexRouteImport.update({
    id: '/ejendomme/',
    path: '/ejendomme/',
    getParentRoute: () => restrictedRouteRoute,
  } as any)
const restrictedEjendommeStreetNumberIdRoute =
  restrictedEjendommeStreetNumberIdRouteImport.update({
    id: '/ejendomme/$streetNumberId',
    path: '/ejendomme/$streetNumberId',
    getParentRoute: () => restrictedRouteRoute,
  } as any)
const restrictedEjendomstjeksearchRouteRoute =
  restrictedEjendomstjeksearchRouteRouteImport.update({
    id: '/ejendomstjek/(search)',
    path: '/ejendomstjek',
    getParentRoute: () => restrictedRouteRoute,
  } as any)
const restrictedEjendomstjekAddressRouteRoute =
  restrictedEjendomstjekAddressRouteRouteImport.update({
    id: '/ejendomstjek/address',
    path: '/ejendomstjek/address',
    getParentRoute: () => restrictedRouteRoute,
  } as any)
const restrictedProfilIndexRoute = restrictedProfilIndexRouteImport.update({
  id: '/profil/',
  path: '/profil/',
  getParentRoute: () => restrictedRouteRoute,
} as any)
const restrictedRapporterIndexRoute =
  restrictedRapporterIndexRouteImport.update({
    id: '/rapporter/',
    path: '/rapporter/',
    getParentRoute: () => restrictedRouteRoute,
  } as any)
const restrictedStaffIndexRoute = restrictedStaffIndexRouteImport.update({
  id: '/staff/',
  path: '/staff/',
  getParentRoute: () => restrictedRouteRoute,
} as any)
const restrictedVirksomhederV2IndexRoute =
  restrictedVirksomhederV2IndexRouteImport.update({
    id: '/virksomheder-v2/',
    path: '/virksomheder-v2/',
    getParentRoute: () => restrictedRouteRoute,
  } as any)
const restrictedVirksomhederCvrRouteRoute =
  restrictedVirksomhederCvrRouteRouteImport.update({
    id: '/virksomheder/$cvr',
    path: '/virksomheder/$cvr',
    getParentRoute: () => restrictedRouteRoute,
  } as any)
const restrictedVirksomhedersearchRouteRoute =
  restrictedVirksomhedersearchRouteRouteImport.update({
    id: '/virksomheder/(search)',
    path: '/virksomheder',
    getParentRoute: () => restrictedRouteRoute,
  } as any)
const AuthResetPasswordTokenRoute = AuthResetPasswordTokenRouteImport.update({
  id: '/reset-password/$token',
  path: '/reset-password/$token',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthVerifyEmailTokenRoute = AuthVerifyEmailTokenRouteImport.update({
  id: '/verify-email/$token',
  path: '/verify-email/$token',
  getParentRoute: () => AuthRouteRoute,
} as any)
const restrictedByggeradarAccesslandingRouteRoute =
  restrictedByggeradarAccesslandingRouteRouteImport.update({
    id: '/(landing)',
    getParentRoute: () => restrictedByggeradarAccessRouteRoute,
  } as any)
const restrictedByggeradarAccessSearchRouteRoute =
  restrictedByggeradarAccessSearchRouteRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => restrictedByggeradarAccessRouteRoute,
  } as any)
const restrictedByggeradarSavedSplatRoute =
  restrictedByggeradarSavedSplatRouteImport.update({
    id: '/byggeradar/saved/$',
    path: '/byggeradar/saved/$',
    getParentRoute: () => restrictedRouteRoute,
  } as any)
const restrictedEjendommeBfeBfeNumberRoute =
  restrictedEjendommeBfeBfeNumberRouteImport.update({
    id: '/ejendomme/bfe/$bfeNumber',
    path: '/ejendomme/bfe/$bfeNumber',
    getParentRoute: () => restrictedRouteRoute,
  } as any)
const restrictedRapporterReportSlugIndexRoute =
  restrictedRapporterReportSlugIndexRouteImport.update({
    id: '/rapporter/$reportSlug/',
    path: '/rapporter/$reportSlug/',
    getParentRoute: () => restrictedRouteRoute,
  } as any)
const restrictedVirksomhederCvrEjerstrukturRoute =
  restrictedVirksomhederCvrEjerstrukturRouteImport.update({
    id: '/ejerstruktur',
    path: '/ejerstruktur',
    getParentRoute: () => restrictedVirksomhederCvrRouteRoute,
  } as any)
const restrictedVirksomhederCvrRegnskabRoute =
  restrictedVirksomhederCvrRegnskabRouteImport.update({
    id: '/regnskab',
    path: '/regnskab',
    getParentRoute: () => restrictedVirksomhederCvrRouteRoute,
  } as any)
const restrictedVirksomhederCvrStamdataRoute =
  restrictedVirksomhederCvrStamdataRouteImport.update({
    id: '/stamdata',
    path: '/stamdata',
    getParentRoute: () => restrictedVirksomhederCvrRouteRoute,
  } as any)
const restrictedByggeradarAccesslandingIndexRoute =
  restrictedByggeradarAccesslandingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => restrictedByggeradarAccesslandingRouteRoute,
  } as any)
const restrictedByggeradarAccessAgentAgentIdRoute =
  restrictedByggeradarAccessAgentAgentIdRouteImport.update({
    id: '/agent/$agentId',
    path: '/agent/$agentId',
    getParentRoute: () => restrictedByggeradarAccessRouteRoute,
  } as any)
const restrictedByggeradarAccessCollectionCollectionIdRoute =
  restrictedByggeradarAccessCollectionCollectionIdRouteImport.update({
    id: '/collection/$collectionId',
    path: '/collection/$collectionId',
    getParentRoute: () => restrictedByggeradarAccessRouteRoute,
  } as any)
const restrictedByggeradarAccessSearchProposalIdRoute =
  restrictedByggeradarAccessSearchProposalIdRouteImport.update({
    id: '/$proposalId',
    path: '/$proposalId',
    getParentRoute: () => restrictedByggeradarAccessSearchRouteRoute,
  } as any)
const restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRoute =
  restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRouteImport.update(
    {
      id: '/$accessAddressId/{-$placeId}',
      path: '/$accessAddressId/{-$placeId}',
      getParentRoute: () => restrictedEjendomstjekAddressRouteRoute,
    } as any,
  )
const restrictedByggeradarAccessAgentAgentIdProposalIdRoute =
  restrictedByggeradarAccessAgentAgentIdProposalIdRouteImport.update({
    id: '/$proposalId',
    path: '/$proposalId',
    getParentRoute: () => restrictedByggeradarAccessAgentAgentIdRoute,
  } as any)
const restrictedByggeradarAccessCollectionCollectionIdProposalIdRoute =
  restrictedByggeradarAccessCollectionCollectionIdProposalIdRouteImport.update({
    id: '/$proposalId',
    path: '/$proposalId',
    getParentRoute: () => restrictedByggeradarAccessCollectionCollectionIdRoute,
  } as any)
const restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125OverviewChar123UnitIdChar125Route =
  restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125OverviewChar123UnitIdChar125RouteImport.update(
    {
      id: '/overview/{-$unitId}',
      path: '/overview/{-$unitId}',
      getParentRoute: () =>
        restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRoute,
    } as any,
  )
const restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RentAnalysisChar123UnitIdChar125Route =
  restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RentAnalysisChar123UnitIdChar125RouteImport.update(
    {
      id: '/rent-analysis/{-$unitId}',
      path: '/rent-analysis/{-$unitId}',
      getParentRoute: () =>
        restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRoute,
    } as any,
  )
const restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RentingOutChar123UnitIdChar125Route =
  restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RentingOutChar123UnitIdChar125RouteImport.update(
    {
      id: '/renting-out/{-$unitId}',
      path: '/renting-out/{-$unitId}',
      getParentRoute: () =>
        restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRoute,
    } as any,
  )
const restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RestrictionsChar123CurrentPlaceIdChar125Route =
  restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RestrictionsChar123CurrentPlaceIdChar125RouteImport.update(
    {
      id: '/restrictions/{-$currentPlaceId}',
      path: '/restrictions/{-$currentPlaceId}',
      getParentRoute: () =>
        restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRoute,
    } as any,
  )
const restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125SalesPricesChar123BfeNumberChar125Route =
  restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125SalesPricesChar123BfeNumberChar125RouteImport.update(
    {
      id: '/sales-prices/{-$bfeNumber}',
      path: '/sales-prices/{-$bfeNumber}',
      getParentRoute: () =>
        restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/byggeradar': typeof restrictedByggeradarAccesslandingRouteRouteWithChildren
  '/ejendomstjek': typeof restrictedEjendomstjeksearchRouteRoute
  '/ejendomstjek/address': typeof restrictedEjendomstjekAddressRouteRouteWithChildren
  '/virksomheder/$cvr': typeof restrictedVirksomhederCvrRouteRouteWithChildren
  '/virksomheder': typeof restrictedVirksomhedersearchRouteRoute
  '/checkout/callback': typeof restrictedCheckoutCallbackRoute
  '/ejendomme/$streetNumberId': typeof restrictedEjendommeStreetNumberIdRoute
  '/auth/reset-password/$token': typeof AuthResetPasswordTokenRoute
  '/auth/verify-email/$token': typeof AuthVerifyEmailTokenRoute
  '/checkout/': typeof restrictedCheckoutIndexRoute
  '/ejendomme/': typeof restrictedEjendommeIndexRoute
  '/profil/': typeof restrictedProfilIndexRoute
  '/rapporter/': typeof restrictedRapporterIndexRoute
  '/staff/': typeof restrictedStaffIndexRoute
  '/virksomheder-v2/': typeof restrictedVirksomhederV2IndexRoute
  '/byggeradar/search': typeof restrictedByggeradarAccessSearchRouteRouteWithChildren
  '/byggeradar/saved/$': typeof restrictedByggeradarSavedSplatRoute
  '/ejendomme/bfe/$bfeNumber': typeof restrictedEjendommeBfeBfeNumberRoute
  '/virksomheder/$cvr/ejerstruktur': typeof restrictedVirksomhederCvrEjerstrukturRoute
  '/virksomheder/$cvr/regnskab': typeof restrictedVirksomhederCvrRegnskabRoute
  '/virksomheder/$cvr/stamdata': typeof restrictedVirksomhederCvrStamdataRoute
  '/rapporter/$reportSlug/': typeof restrictedRapporterReportSlugIndexRoute
  '/ejendomstjek/address/$accessAddressId/{-$placeId}': typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRouteWithChildren
  '/byggeradar/agent/$agentId': typeof restrictedByggeradarAccessAgentAgentIdRouteWithChildren
  '/byggeradar/collection/$collectionId': typeof restrictedByggeradarAccessCollectionCollectionIdRouteWithChildren
  '/byggeradar/search/$proposalId': typeof restrictedByggeradarAccessSearchProposalIdRoute
  '/byggeradar/': typeof restrictedByggeradarAccesslandingIndexRoute
  '/byggeradar/agent/$agentId/$proposalId': typeof restrictedByggeradarAccessAgentAgentIdProposalIdRoute
  '/byggeradar/collection/$collectionId/$proposalId': typeof restrictedByggeradarAccessCollectionCollectionIdProposalIdRoute
  '/ejendomstjek/address/$accessAddressId/{-$placeId}/overview/{-$unitId}': typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125OverviewChar123UnitIdChar125Route
  '/ejendomstjek/address/$accessAddressId/{-$placeId}/rent-analysis/{-$unitId}': typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RentAnalysisChar123UnitIdChar125Route
  '/ejendomstjek/address/$accessAddressId/{-$placeId}/renting-out/{-$unitId}': typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RentingOutChar123UnitIdChar125Route
  '/ejendomstjek/address/$accessAddressId/{-$placeId}/restrictions/{-$currentPlaceId}': typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RestrictionsChar123CurrentPlaceIdChar125Route
  '/ejendomstjek/address/$accessAddressId/{-$placeId}/sales-prices/{-$bfeNumber}': typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125SalesPricesChar123BfeNumberChar125Route
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/byggeradar': typeof restrictedByggeradarAccesslandingIndexRoute
  '/ejendomstjek': typeof restrictedEjendomstjeksearchRouteRoute
  '/ejendomstjek/address': typeof restrictedEjendomstjekAddressRouteRouteWithChildren
  '/virksomheder/$cvr': typeof restrictedVirksomhederCvrRouteRouteWithChildren
  '/virksomheder': typeof restrictedVirksomhedersearchRouteRoute
  '/checkout/callback': typeof restrictedCheckoutCallbackRoute
  '/ejendomme/$streetNumberId': typeof restrictedEjendommeStreetNumberIdRoute
  '/auth/reset-password/$token': typeof AuthResetPasswordTokenRoute
  '/auth/verify-email/$token': typeof AuthVerifyEmailTokenRoute
  '/checkout': typeof restrictedCheckoutIndexRoute
  '/ejendomme': typeof restrictedEjendommeIndexRoute
  '/profil': typeof restrictedProfilIndexRoute
  '/rapporter': typeof restrictedRapporterIndexRoute
  '/staff': typeof restrictedStaffIndexRoute
  '/virksomheder-v2': typeof restrictedVirksomhederV2IndexRoute
  '/byggeradar/search': typeof restrictedByggeradarAccessSearchRouteRouteWithChildren
  '/byggeradar/saved/$': typeof restrictedByggeradarSavedSplatRoute
  '/ejendomme/bfe/$bfeNumber': typeof restrictedEjendommeBfeBfeNumberRoute
  '/virksomheder/$cvr/ejerstruktur': typeof restrictedVirksomhederCvrEjerstrukturRoute
  '/virksomheder/$cvr/regnskab': typeof restrictedVirksomhederCvrRegnskabRoute
  '/virksomheder/$cvr/stamdata': typeof restrictedVirksomhederCvrStamdataRoute
  '/rapporter/$reportSlug': typeof restrictedRapporterReportSlugIndexRoute
  '/ejendomstjek/address/$accessAddressId/{-$placeId}': typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRouteWithChildren
  '/byggeradar/agent/$agentId': typeof restrictedByggeradarAccessAgentAgentIdRouteWithChildren
  '/byggeradar/collection/$collectionId': typeof restrictedByggeradarAccessCollectionCollectionIdRouteWithChildren
  '/byggeradar/search/$proposalId': typeof restrictedByggeradarAccessSearchProposalIdRoute
  '/byggeradar/agent/$agentId/$proposalId': typeof restrictedByggeradarAccessAgentAgentIdProposalIdRoute
  '/byggeradar/collection/$collectionId/$proposalId': typeof restrictedByggeradarAccessCollectionCollectionIdProposalIdRoute
  '/ejendomstjek/address/$accessAddressId/{-$placeId}/overview/{-$unitId}': typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125OverviewChar123UnitIdChar125Route
  '/ejendomstjek/address/$accessAddressId/{-$placeId}/rent-analysis/{-$unitId}': typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RentAnalysisChar123UnitIdChar125Route
  '/ejendomstjek/address/$accessAddressId/{-$placeId}/renting-out/{-$unitId}': typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RentingOutChar123UnitIdChar125Route
  '/ejendomstjek/address/$accessAddressId/{-$placeId}/restrictions/{-$currentPlaceId}': typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RestrictionsChar123CurrentPlaceIdChar125Route
  '/ejendomstjek/address/$accessAddressId/{-$placeId}/sales-prices/{-$bfeNumber}': typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125SalesPricesChar123BfeNumberChar125Route
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(restricted)': typeof restrictedRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/(restricted)/byggeradar/_access': typeof restrictedByggeradarAccessRouteRouteWithChildren
  '/(restricted)/ejendomstjek/(search)': typeof restrictedEjendomstjeksearchRouteRoute
  '/(restricted)/ejendomstjek/address': typeof restrictedEjendomstjekAddressRouteRouteWithChildren
  '/(restricted)/virksomheder/$cvr': typeof restrictedVirksomhederCvrRouteRouteWithChildren
  '/(restricted)/virksomheder/(search)': typeof restrictedVirksomhedersearchRouteRoute
  '/(restricted)/checkout/callback': typeof restrictedCheckoutCallbackRoute
  '/(restricted)/ejendomme/$streetNumberId': typeof restrictedEjendommeStreetNumberIdRoute
  '/auth/reset-password/$token': typeof AuthResetPasswordTokenRoute
  '/auth/verify-email/$token': typeof AuthVerifyEmailTokenRoute
  '/(restricted)/checkout/': typeof restrictedCheckoutIndexRoute
  '/(restricted)/ejendomme/': typeof restrictedEjendommeIndexRoute
  '/(restricted)/profil/': typeof restrictedProfilIndexRoute
  '/(restricted)/rapporter/': typeof restrictedRapporterIndexRoute
  '/(restricted)/staff/': typeof restrictedStaffIndexRoute
  '/(restricted)/virksomheder-v2/': typeof restrictedVirksomhederV2IndexRoute
  '/(restricted)/byggeradar/_access/(landing)': typeof restrictedByggeradarAccesslandingRouteRouteWithChildren
  '/(restricted)/byggeradar/_access/search': typeof restrictedByggeradarAccessSearchRouteRouteWithChildren
  '/(restricted)/byggeradar/saved/$': typeof restrictedByggeradarSavedSplatRoute
  '/(restricted)/ejendomme/bfe/$bfeNumber': typeof restrictedEjendommeBfeBfeNumberRoute
  '/(restricted)/virksomheder/$cvr/ejerstruktur': typeof restrictedVirksomhederCvrEjerstrukturRoute
  '/(restricted)/virksomheder/$cvr/regnskab': typeof restrictedVirksomhederCvrRegnskabRoute
  '/(restricted)/virksomheder/$cvr/stamdata': typeof restrictedVirksomhederCvrStamdataRoute
  '/(restricted)/rapporter/$reportSlug/': typeof restrictedRapporterReportSlugIndexRoute
  '/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}': typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRouteWithChildren
  '/(restricted)/byggeradar/_access/agent/$agentId': typeof restrictedByggeradarAccessAgentAgentIdRouteWithChildren
  '/(restricted)/byggeradar/_access/collection/$collectionId': typeof restrictedByggeradarAccessCollectionCollectionIdRouteWithChildren
  '/(restricted)/byggeradar/_access/search/$proposalId': typeof restrictedByggeradarAccessSearchProposalIdRoute
  '/(restricted)/byggeradar/_access/(landing)/': typeof restrictedByggeradarAccesslandingIndexRoute
  '/(restricted)/byggeradar/_access/agent/$agentId/$proposalId': typeof restrictedByggeradarAccessAgentAgentIdProposalIdRoute
  '/(restricted)/byggeradar/_access/collection/$collectionId/$proposalId': typeof restrictedByggeradarAccessCollectionCollectionIdProposalIdRoute
  '/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/overview/{-$unitId}': typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125OverviewChar123UnitIdChar125Route
  '/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/rent-analysis/{-$unitId}': typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RentAnalysisChar123UnitIdChar125Route
  '/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/renting-out/{-$unitId}': typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RentingOutChar123UnitIdChar125Route
  '/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/restrictions/{-$currentPlaceId}': typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RestrictionsChar123CurrentPlaceIdChar125Route
  '/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/sales-prices/{-$bfeNumber}': typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125SalesPricesChar123BfeNumberChar125Route
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/byggeradar'
    | '/ejendomstjek'
    | '/ejendomstjek/address'
    | '/virksomheder/$cvr'
    | '/virksomheder'
    | '/checkout/callback'
    | '/ejendomme/$streetNumberId'
    | '/auth/reset-password/$token'
    | '/auth/verify-email/$token'
    | '/checkout/'
    | '/ejendomme/'
    | '/profil/'
    | '/rapporter/'
    | '/staff/'
    | '/virksomheder-v2/'
    | '/byggeradar/search'
    | '/byggeradar/saved/$'
    | '/ejendomme/bfe/$bfeNumber'
    | '/virksomheder/$cvr/ejerstruktur'
    | '/virksomheder/$cvr/regnskab'
    | '/virksomheder/$cvr/stamdata'
    | '/rapporter/$reportSlug/'
    | '/ejendomstjek/address/$accessAddressId/{-$placeId}'
    | '/byggeradar/agent/$agentId'
    | '/byggeradar/collection/$collectionId'
    | '/byggeradar/search/$proposalId'
    | '/byggeradar/'
    | '/byggeradar/agent/$agentId/$proposalId'
    | '/byggeradar/collection/$collectionId/$proposalId'
    | '/ejendomstjek/address/$accessAddressId/{-$placeId}/overview/{-$unitId}'
    | '/ejendomstjek/address/$accessAddressId/{-$placeId}/rent-analysis/{-$unitId}'
    | '/ejendomstjek/address/$accessAddressId/{-$placeId}/renting-out/{-$unitId}'
    | '/ejendomstjek/address/$accessAddressId/{-$placeId}/restrictions/{-$currentPlaceId}'
    | '/ejendomstjek/address/$accessAddressId/{-$placeId}/sales-prices/{-$bfeNumber}'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/byggeradar'
    | '/ejendomstjek'
    | '/ejendomstjek/address'
    | '/virksomheder/$cvr'
    | '/virksomheder'
    | '/checkout/callback'
    | '/ejendomme/$streetNumberId'
    | '/auth/reset-password/$token'
    | '/auth/verify-email/$token'
    | '/checkout'
    | '/ejendomme'
    | '/profil'
    | '/rapporter'
    | '/staff'
    | '/virksomheder-v2'
    | '/byggeradar/search'
    | '/byggeradar/saved/$'
    | '/ejendomme/bfe/$bfeNumber'
    | '/virksomheder/$cvr/ejerstruktur'
    | '/virksomheder/$cvr/regnskab'
    | '/virksomheder/$cvr/stamdata'
    | '/rapporter/$reportSlug'
    | '/ejendomstjek/address/$accessAddressId/{-$placeId}'
    | '/byggeradar/agent/$agentId'
    | '/byggeradar/collection/$collectionId'
    | '/byggeradar/search/$proposalId'
    | '/byggeradar/agent/$agentId/$proposalId'
    | '/byggeradar/collection/$collectionId/$proposalId'
    | '/ejendomstjek/address/$accessAddressId/{-$placeId}/overview/{-$unitId}'
    | '/ejendomstjek/address/$accessAddressId/{-$placeId}/rent-analysis/{-$unitId}'
    | '/ejendomstjek/address/$accessAddressId/{-$placeId}/renting-out/{-$unitId}'
    | '/ejendomstjek/address/$accessAddressId/{-$placeId}/restrictions/{-$currentPlaceId}'
    | '/ejendomstjek/address/$accessAddressId/{-$placeId}/sales-prices/{-$bfeNumber}'
  id:
    | '__root__'
    | '/'
    | '/(restricted)'
    | '/auth'
    | '/(restricted)/byggeradar/_access'
    | '/(restricted)/ejendomstjek/(search)'
    | '/(restricted)/ejendomstjek/address'
    | '/(restricted)/virksomheder/$cvr'
    | '/(restricted)/virksomheder/(search)'
    | '/(restricted)/checkout/callback'
    | '/(restricted)/ejendomme/$streetNumberId'
    | '/auth/reset-password/$token'
    | '/auth/verify-email/$token'
    | '/(restricted)/checkout/'
    | '/(restricted)/ejendomme/'
    | '/(restricted)/profil/'
    | '/(restricted)/rapporter/'
    | '/(restricted)/staff/'
    | '/(restricted)/virksomheder-v2/'
    | '/(restricted)/byggeradar/_access/(landing)'
    | '/(restricted)/byggeradar/_access/search'
    | '/(restricted)/byggeradar/saved/$'
    | '/(restricted)/ejendomme/bfe/$bfeNumber'
    | '/(restricted)/virksomheder/$cvr/ejerstruktur'
    | '/(restricted)/virksomheder/$cvr/regnskab'
    | '/(restricted)/virksomheder/$cvr/stamdata'
    | '/(restricted)/rapporter/$reportSlug/'
    | '/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}'
    | '/(restricted)/byggeradar/_access/agent/$agentId'
    | '/(restricted)/byggeradar/_access/collection/$collectionId'
    | '/(restricted)/byggeradar/_access/search/$proposalId'
    | '/(restricted)/byggeradar/_access/(landing)/'
    | '/(restricted)/byggeradar/_access/agent/$agentId/$proposalId'
    | '/(restricted)/byggeradar/_access/collection/$collectionId/$proposalId'
    | '/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/overview/{-$unitId}'
    | '/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/rent-analysis/{-$unitId}'
    | '/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/renting-out/{-$unitId}'
    | '/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/restrictions/{-$currentPlaceId}'
    | '/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/sales-prices/{-$bfeNumber}'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  restrictedRouteRoute: typeof restrictedRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(restricted)': {
      id: '/(restricted)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof restrictedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(restricted)/byggeradar/_access': {
      id: '/(restricted)/byggeradar/_access'
      path: '/byggeradar'
      fullPath: '/byggeradar'
      preLoaderRoute: typeof restrictedByggeradarAccessRouteRouteImport
      parentRoute: typeof restrictedRouteRoute
    }
    '/(restricted)/checkout/': {
      id: '/(restricted)/checkout/'
      path: '/checkout'
      fullPath: '/checkout/'
      preLoaderRoute: typeof restrictedCheckoutIndexRouteImport
      parentRoute: typeof restrictedRouteRoute
    }
    '/(restricted)/checkout/callback': {
      id: '/(restricted)/checkout/callback'
      path: '/checkout/callback'
      fullPath: '/checkout/callback'
      preLoaderRoute: typeof restrictedCheckoutCallbackRouteImport
      parentRoute: typeof restrictedRouteRoute
    }
    '/(restricted)/ejendomme/': {
      id: '/(restricted)/ejendomme/'
      path: '/ejendomme'
      fullPath: '/ejendomme/'
      preLoaderRoute: typeof restrictedEjendommeIndexRouteImport
      parentRoute: typeof restrictedRouteRoute
    }
    '/(restricted)/ejendomme/$streetNumberId': {
      id: '/(restricted)/ejendomme/$streetNumberId'
      path: '/ejendomme/$streetNumberId'
      fullPath: '/ejendomme/$streetNumberId'
      preLoaderRoute: typeof restrictedEjendommeStreetNumberIdRouteImport
      parentRoute: typeof restrictedRouteRoute
    }
    '/(restricted)/ejendomstjek/(search)': {
      id: '/(restricted)/ejendomstjek/(search)'
      path: '/ejendomstjek'
      fullPath: '/ejendomstjek'
      preLoaderRoute: typeof restrictedEjendomstjeksearchRouteRouteImport
      parentRoute: typeof restrictedRouteRoute
    }
    '/(restricted)/ejendomstjek/address': {
      id: '/(restricted)/ejendomstjek/address'
      path: '/ejendomstjek/address'
      fullPath: '/ejendomstjek/address'
      preLoaderRoute: typeof restrictedEjendomstjekAddressRouteRouteImport
      parentRoute: typeof restrictedRouteRoute
    }
    '/(restricted)/profil/': {
      id: '/(restricted)/profil/'
      path: '/profil'
      fullPath: '/profil/'
      preLoaderRoute: typeof restrictedProfilIndexRouteImport
      parentRoute: typeof restrictedRouteRoute
    }
    '/(restricted)/rapporter/': {
      id: '/(restricted)/rapporter/'
      path: '/rapporter'
      fullPath: '/rapporter/'
      preLoaderRoute: typeof restrictedRapporterIndexRouteImport
      parentRoute: typeof restrictedRouteRoute
    }
    '/(restricted)/staff/': {
      id: '/(restricted)/staff/'
      path: '/staff'
      fullPath: '/staff/'
      preLoaderRoute: typeof restrictedStaffIndexRouteImport
      parentRoute: typeof restrictedRouteRoute
    }
    '/(restricted)/virksomheder-v2/': {
      id: '/(restricted)/virksomheder-v2/'
      path: '/virksomheder-v2'
      fullPath: '/virksomheder-v2/'
      preLoaderRoute: typeof restrictedVirksomhederV2IndexRouteImport
      parentRoute: typeof restrictedRouteRoute
    }
    '/(restricted)/virksomheder/$cvr': {
      id: '/(restricted)/virksomheder/$cvr'
      path: '/virksomheder/$cvr'
      fullPath: '/virksomheder/$cvr'
      preLoaderRoute: typeof restrictedVirksomhederCvrRouteRouteImport
      parentRoute: typeof restrictedRouteRoute
    }
    '/(restricted)/virksomheder/(search)': {
      id: '/(restricted)/virksomheder/(search)'
      path: '/virksomheder'
      fullPath: '/virksomheder'
      preLoaderRoute: typeof restrictedVirksomhedersearchRouteRouteImport
      parentRoute: typeof restrictedRouteRoute
    }
    '/auth/reset-password/$token': {
      id: '/auth/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/auth/reset-password/$token'
      preLoaderRoute: typeof AuthResetPasswordTokenRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/verify-email/$token': {
      id: '/auth/verify-email/$token'
      path: '/verify-email/$token'
      fullPath: '/auth/verify-email/$token'
      preLoaderRoute: typeof AuthVerifyEmailTokenRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/(restricted)/byggeradar/_access/(landing)': {
      id: '/(restricted)/byggeradar/_access/(landing)'
      path: ''
      fullPath: '/byggeradar'
      preLoaderRoute: typeof restrictedByggeradarAccesslandingRouteRouteImport
      parentRoute: typeof restrictedByggeradarAccessRouteRoute
    }
    '/(restricted)/byggeradar/_access/search': {
      id: '/(restricted)/byggeradar/_access/search'
      path: '/search'
      fullPath: '/byggeradar/search'
      preLoaderRoute: typeof restrictedByggeradarAccessSearchRouteRouteImport
      parentRoute: typeof restrictedByggeradarAccessRouteRoute
    }
    '/(restricted)/byggeradar/saved/$': {
      id: '/(restricted)/byggeradar/saved/$'
      path: '/byggeradar/saved/$'
      fullPath: '/byggeradar/saved/$'
      preLoaderRoute: typeof restrictedByggeradarSavedSplatRouteImport
      parentRoute: typeof restrictedRouteRoute
    }
    '/(restricted)/ejendomme/bfe/$bfeNumber': {
      id: '/(restricted)/ejendomme/bfe/$bfeNumber'
      path: '/ejendomme/bfe/$bfeNumber'
      fullPath: '/ejendomme/bfe/$bfeNumber'
      preLoaderRoute: typeof restrictedEjendommeBfeBfeNumberRouteImport
      parentRoute: typeof restrictedRouteRoute
    }
    '/(restricted)/rapporter/$reportSlug/': {
      id: '/(restricted)/rapporter/$reportSlug/'
      path: '/rapporter/$reportSlug'
      fullPath: '/rapporter/$reportSlug/'
      preLoaderRoute: typeof restrictedRapporterReportSlugIndexRouteImport
      parentRoute: typeof restrictedRouteRoute
    }
    '/(restricted)/virksomheder/$cvr/ejerstruktur': {
      id: '/(restricted)/virksomheder/$cvr/ejerstruktur'
      path: '/ejerstruktur'
      fullPath: '/virksomheder/$cvr/ejerstruktur'
      preLoaderRoute: typeof restrictedVirksomhederCvrEjerstrukturRouteImport
      parentRoute: typeof restrictedVirksomhederCvrRouteRoute
    }
    '/(restricted)/virksomheder/$cvr/regnskab': {
      id: '/(restricted)/virksomheder/$cvr/regnskab'
      path: '/regnskab'
      fullPath: '/virksomheder/$cvr/regnskab'
      preLoaderRoute: typeof restrictedVirksomhederCvrRegnskabRouteImport
      parentRoute: typeof restrictedVirksomhederCvrRouteRoute
    }
    '/(restricted)/virksomheder/$cvr/stamdata': {
      id: '/(restricted)/virksomheder/$cvr/stamdata'
      path: '/stamdata'
      fullPath: '/virksomheder/$cvr/stamdata'
      preLoaderRoute: typeof restrictedVirksomhederCvrStamdataRouteImport
      parentRoute: typeof restrictedVirksomhederCvrRouteRoute
    }
    '/(restricted)/byggeradar/_access/(landing)/': {
      id: '/(restricted)/byggeradar/_access/(landing)/'
      path: '/'
      fullPath: '/byggeradar/'
      preLoaderRoute: typeof restrictedByggeradarAccesslandingIndexRouteImport
      parentRoute: typeof restrictedByggeradarAccesslandingRouteRoute
    }
    '/(restricted)/byggeradar/_access/agent/$agentId': {
      id: '/(restricted)/byggeradar/_access/agent/$agentId'
      path: '/agent/$agentId'
      fullPath: '/byggeradar/agent/$agentId'
      preLoaderRoute: typeof restrictedByggeradarAccessAgentAgentIdRouteImport
      parentRoute: typeof restrictedByggeradarAccessRouteRoute
    }
    '/(restricted)/byggeradar/_access/collection/$collectionId': {
      id: '/(restricted)/byggeradar/_access/collection/$collectionId'
      path: '/collection/$collectionId'
      fullPath: '/byggeradar/collection/$collectionId'
      preLoaderRoute: typeof restrictedByggeradarAccessCollectionCollectionIdRouteImport
      parentRoute: typeof restrictedByggeradarAccessRouteRoute
    }
    '/(restricted)/byggeradar/_access/search/$proposalId': {
      id: '/(restricted)/byggeradar/_access/search/$proposalId'
      path: '/$proposalId'
      fullPath: '/byggeradar/search/$proposalId'
      preLoaderRoute: typeof restrictedByggeradarAccessSearchProposalIdRouteImport
      parentRoute: typeof restrictedByggeradarAccessSearchRouteRoute
    }
    '/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}': {
      id: '/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}'
      path: '/$accessAddressId/{-$placeId}'
      fullPath: '/ejendomstjek/address/$accessAddressId/{-$placeId}'
      preLoaderRoute: typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRouteImport
      parentRoute: typeof restrictedEjendomstjekAddressRouteRoute
    }
    '/(restricted)/byggeradar/_access/agent/$agentId/$proposalId': {
      id: '/(restricted)/byggeradar/_access/agent/$agentId/$proposalId'
      path: '/$proposalId'
      fullPath: '/byggeradar/agent/$agentId/$proposalId'
      preLoaderRoute: typeof restrictedByggeradarAccessAgentAgentIdProposalIdRouteImport
      parentRoute: typeof restrictedByggeradarAccessAgentAgentIdRoute
    }
    '/(restricted)/byggeradar/_access/collection/$collectionId/$proposalId': {
      id: '/(restricted)/byggeradar/_access/collection/$collectionId/$proposalId'
      path: '/$proposalId'
      fullPath: '/byggeradar/collection/$collectionId/$proposalId'
      preLoaderRoute: typeof restrictedByggeradarAccessCollectionCollectionIdProposalIdRouteImport
      parentRoute: typeof restrictedByggeradarAccessCollectionCollectionIdRoute
    }
    '/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/overview/{-$unitId}': {
      id: '/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/overview/{-$unitId}'
      path: '/overview/{-$unitId}'
      fullPath: '/ejendomstjek/address/$accessAddressId/{-$placeId}/overview/{-$unitId}'
      preLoaderRoute: typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125OverviewChar123UnitIdChar125RouteImport
      parentRoute: typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRoute
    }
    '/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/rent-analysis/{-$unitId}': {
      id: '/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/rent-analysis/{-$unitId}'
      path: '/rent-analysis/{-$unitId}'
      fullPath: '/ejendomstjek/address/$accessAddressId/{-$placeId}/rent-analysis/{-$unitId}'
      preLoaderRoute: typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RentAnalysisChar123UnitIdChar125RouteImport
      parentRoute: typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRoute
    }
    '/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/renting-out/{-$unitId}': {
      id: '/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/renting-out/{-$unitId}'
      path: '/renting-out/{-$unitId}'
      fullPath: '/ejendomstjek/address/$accessAddressId/{-$placeId}/renting-out/{-$unitId}'
      preLoaderRoute: typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RentingOutChar123UnitIdChar125RouteImport
      parentRoute: typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRoute
    }
    '/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/restrictions/{-$currentPlaceId}': {
      id: '/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/restrictions/{-$currentPlaceId}'
      path: '/restrictions/{-$currentPlaceId}'
      fullPath: '/ejendomstjek/address/$accessAddressId/{-$placeId}/restrictions/{-$currentPlaceId}'
      preLoaderRoute: typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RestrictionsChar123CurrentPlaceIdChar125RouteImport
      parentRoute: typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRoute
    }
    '/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/sales-prices/{-$bfeNumber}': {
      id: '/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/sales-prices/{-$bfeNumber}'
      path: '/sales-prices/{-$bfeNumber}'
      fullPath: '/ejendomstjek/address/$accessAddressId/{-$placeId}/sales-prices/{-$bfeNumber}'
      preLoaderRoute: typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125SalesPricesChar123BfeNumberChar125RouteImport
      parentRoute: typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRoute
    }
  }
}

interface restrictedByggeradarAccesslandingRouteRouteChildren {
  restrictedByggeradarAccesslandingIndexRoute: typeof restrictedByggeradarAccesslandingIndexRoute
}

const restrictedByggeradarAccesslandingRouteRouteChildren: restrictedByggeradarAccesslandingRouteRouteChildren =
  {
    restrictedByggeradarAccesslandingIndexRoute:
      restrictedByggeradarAccesslandingIndexRoute,
  }

const restrictedByggeradarAccesslandingRouteRouteWithChildren =
  restrictedByggeradarAccesslandingRouteRoute._addFileChildren(
    restrictedByggeradarAccesslandingRouteRouteChildren,
  )

interface restrictedByggeradarAccessSearchRouteRouteChildren {
  restrictedByggeradarAccessSearchProposalIdRoute: typeof restrictedByggeradarAccessSearchProposalIdRoute
}

const restrictedByggeradarAccessSearchRouteRouteChildren: restrictedByggeradarAccessSearchRouteRouteChildren =
  {
    restrictedByggeradarAccessSearchProposalIdRoute:
      restrictedByggeradarAccessSearchProposalIdRoute,
  }

const restrictedByggeradarAccessSearchRouteRouteWithChildren =
  restrictedByggeradarAccessSearchRouteRoute._addFileChildren(
    restrictedByggeradarAccessSearchRouteRouteChildren,
  )

interface restrictedByggeradarAccessAgentAgentIdRouteChildren {
  restrictedByggeradarAccessAgentAgentIdProposalIdRoute: typeof restrictedByggeradarAccessAgentAgentIdProposalIdRoute
}

const restrictedByggeradarAccessAgentAgentIdRouteChildren: restrictedByggeradarAccessAgentAgentIdRouteChildren =
  {
    restrictedByggeradarAccessAgentAgentIdProposalIdRoute:
      restrictedByggeradarAccessAgentAgentIdProposalIdRoute,
  }

const restrictedByggeradarAccessAgentAgentIdRouteWithChildren =
  restrictedByggeradarAccessAgentAgentIdRoute._addFileChildren(
    restrictedByggeradarAccessAgentAgentIdRouteChildren,
  )

interface restrictedByggeradarAccessCollectionCollectionIdRouteChildren {
  restrictedByggeradarAccessCollectionCollectionIdProposalIdRoute: typeof restrictedByggeradarAccessCollectionCollectionIdProposalIdRoute
}

const restrictedByggeradarAccessCollectionCollectionIdRouteChildren: restrictedByggeradarAccessCollectionCollectionIdRouteChildren =
  {
    restrictedByggeradarAccessCollectionCollectionIdProposalIdRoute:
      restrictedByggeradarAccessCollectionCollectionIdProposalIdRoute,
  }

const restrictedByggeradarAccessCollectionCollectionIdRouteWithChildren =
  restrictedByggeradarAccessCollectionCollectionIdRoute._addFileChildren(
    restrictedByggeradarAccessCollectionCollectionIdRouteChildren,
  )

interface restrictedByggeradarAccessRouteRouteChildren {
  restrictedByggeradarAccesslandingRouteRoute: typeof restrictedByggeradarAccesslandingRouteRouteWithChildren
  restrictedByggeradarAccessSearchRouteRoute: typeof restrictedByggeradarAccessSearchRouteRouteWithChildren
  restrictedByggeradarAccessAgentAgentIdRoute: typeof restrictedByggeradarAccessAgentAgentIdRouteWithChildren
  restrictedByggeradarAccessCollectionCollectionIdRoute: typeof restrictedByggeradarAccessCollectionCollectionIdRouteWithChildren
}

const restrictedByggeradarAccessRouteRouteChildren: restrictedByggeradarAccessRouteRouteChildren =
  {
    restrictedByggeradarAccesslandingRouteRoute:
      restrictedByggeradarAccesslandingRouteRouteWithChildren,
    restrictedByggeradarAccessSearchRouteRoute:
      restrictedByggeradarAccessSearchRouteRouteWithChildren,
    restrictedByggeradarAccessAgentAgentIdRoute:
      restrictedByggeradarAccessAgentAgentIdRouteWithChildren,
    restrictedByggeradarAccessCollectionCollectionIdRoute:
      restrictedByggeradarAccessCollectionCollectionIdRouteWithChildren,
  }

const restrictedByggeradarAccessRouteRouteWithChildren =
  restrictedByggeradarAccessRouteRoute._addFileChildren(
    restrictedByggeradarAccessRouteRouteChildren,
  )

interface restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRouteChildren {
  restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125OverviewChar123UnitIdChar125Route: typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125OverviewChar123UnitIdChar125Route
  restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RentAnalysisChar123UnitIdChar125Route: typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RentAnalysisChar123UnitIdChar125Route
  restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RentingOutChar123UnitIdChar125Route: typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RentingOutChar123UnitIdChar125Route
  restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RestrictionsChar123CurrentPlaceIdChar125Route: typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RestrictionsChar123CurrentPlaceIdChar125Route
  restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125SalesPricesChar123BfeNumberChar125Route: typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125SalesPricesChar123BfeNumberChar125Route
}

const restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRouteChildren: restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRouteChildren =
  {
    restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125OverviewChar123UnitIdChar125Route:
      restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125OverviewChar123UnitIdChar125Route,
    restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RentAnalysisChar123UnitIdChar125Route:
      restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RentAnalysisChar123UnitIdChar125Route,
    restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RentingOutChar123UnitIdChar125Route:
      restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RentingOutChar123UnitIdChar125Route,
    restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RestrictionsChar123CurrentPlaceIdChar125Route:
      restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RestrictionsChar123CurrentPlaceIdChar125Route,
    restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125SalesPricesChar123BfeNumberChar125Route:
      restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125SalesPricesChar123BfeNumberChar125Route,
  }

const restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRouteWithChildren =
  restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRoute._addFileChildren(
    restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRouteChildren,
  )

interface restrictedEjendomstjekAddressRouteRouteChildren {
  restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRoute: typeof restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRouteWithChildren
}

const restrictedEjendomstjekAddressRouteRouteChildren: restrictedEjendomstjekAddressRouteRouteChildren =
  {
    restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRoute:
      restrictedEjendomstjekAddressAccessAddressIdChar123PlaceIdChar125RouteRouteWithChildren,
  }

const restrictedEjendomstjekAddressRouteRouteWithChildren =
  restrictedEjendomstjekAddressRouteRoute._addFileChildren(
    restrictedEjendomstjekAddressRouteRouteChildren,
  )

interface restrictedVirksomhederCvrRouteRouteChildren {
  restrictedVirksomhederCvrEjerstrukturRoute: typeof restrictedVirksomhederCvrEjerstrukturRoute
  restrictedVirksomhederCvrRegnskabRoute: typeof restrictedVirksomhederCvrRegnskabRoute
  restrictedVirksomhederCvrStamdataRoute: typeof restrictedVirksomhederCvrStamdataRoute
}

const restrictedVirksomhederCvrRouteRouteChildren: restrictedVirksomhederCvrRouteRouteChildren =
  {
    restrictedVirksomhederCvrEjerstrukturRoute:
      restrictedVirksomhederCvrEjerstrukturRoute,
    restrictedVirksomhederCvrRegnskabRoute:
      restrictedVirksomhederCvrRegnskabRoute,
    restrictedVirksomhederCvrStamdataRoute:
      restrictedVirksomhederCvrStamdataRoute,
  }

const restrictedVirksomhederCvrRouteRouteWithChildren =
  restrictedVirksomhederCvrRouteRoute._addFileChildren(
    restrictedVirksomhederCvrRouteRouteChildren,
  )

interface restrictedRouteRouteChildren {
  restrictedByggeradarAccessRouteRoute: typeof restrictedByggeradarAccessRouteRouteWithChildren
  restrictedEjendomstjeksearchRouteRoute: typeof restrictedEjendomstjeksearchRouteRoute
  restrictedEjendomstjekAddressRouteRoute: typeof restrictedEjendomstjekAddressRouteRouteWithChildren
  restrictedVirksomhederCvrRouteRoute: typeof restrictedVirksomhederCvrRouteRouteWithChildren
  restrictedVirksomhedersearchRouteRoute: typeof restrictedVirksomhedersearchRouteRoute
  restrictedCheckoutCallbackRoute: typeof restrictedCheckoutCallbackRoute
  restrictedEjendommeStreetNumberIdRoute: typeof restrictedEjendommeStreetNumberIdRoute
  restrictedCheckoutIndexRoute: typeof restrictedCheckoutIndexRoute
  restrictedEjendommeIndexRoute: typeof restrictedEjendommeIndexRoute
  restrictedProfilIndexRoute: typeof restrictedProfilIndexRoute
  restrictedRapporterIndexRoute: typeof restrictedRapporterIndexRoute
  restrictedStaffIndexRoute: typeof restrictedStaffIndexRoute
  restrictedVirksomhederV2IndexRoute: typeof restrictedVirksomhederV2IndexRoute
  restrictedByggeradarSavedSplatRoute: typeof restrictedByggeradarSavedSplatRoute
  restrictedEjendommeBfeBfeNumberRoute: typeof restrictedEjendommeBfeBfeNumberRoute
  restrictedRapporterReportSlugIndexRoute: typeof restrictedRapporterReportSlugIndexRoute
}

const restrictedRouteRouteChildren: restrictedRouteRouteChildren = {
  restrictedByggeradarAccessRouteRoute:
    restrictedByggeradarAccessRouteRouteWithChildren,
  restrictedEjendomstjeksearchRouteRoute:
    restrictedEjendomstjeksearchRouteRoute,
  restrictedEjendomstjekAddressRouteRoute:
    restrictedEjendomstjekAddressRouteRouteWithChildren,
  restrictedVirksomhederCvrRouteRoute:
    restrictedVirksomhederCvrRouteRouteWithChildren,
  restrictedVirksomhedersearchRouteRoute:
    restrictedVirksomhedersearchRouteRoute,
  restrictedCheckoutCallbackRoute: restrictedCheckoutCallbackRoute,
  restrictedEjendommeStreetNumberIdRoute:
    restrictedEjendommeStreetNumberIdRoute,
  restrictedCheckoutIndexRoute: restrictedCheckoutIndexRoute,
  restrictedEjendommeIndexRoute: restrictedEjendommeIndexRoute,
  restrictedProfilIndexRoute: restrictedProfilIndexRoute,
  restrictedRapporterIndexRoute: restrictedRapporterIndexRoute,
  restrictedStaffIndexRoute: restrictedStaffIndexRoute,
  restrictedVirksomhederV2IndexRoute: restrictedVirksomhederV2IndexRoute,
  restrictedByggeradarSavedSplatRoute: restrictedByggeradarSavedSplatRoute,
  restrictedEjendommeBfeBfeNumberRoute: restrictedEjendommeBfeBfeNumberRoute,
  restrictedRapporterReportSlugIndexRoute:
    restrictedRapporterReportSlugIndexRoute,
}

const restrictedRouteRouteWithChildren = restrictedRouteRoute._addFileChildren(
  restrictedRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthResetPasswordTokenRoute: typeof AuthResetPasswordTokenRoute
  AuthVerifyEmailTokenRoute: typeof AuthVerifyEmailTokenRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthResetPasswordTokenRoute: AuthResetPasswordTokenRoute,
  AuthVerifyEmailTokenRoute: AuthVerifyEmailTokenRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  restrictedRouteRoute: restrictedRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
